module.exports = __webpack_public_path__ + "img/ppdc.50a4d4d4.png";